export default {
    SET_NOTIFICATIONS(state, notifications) {
        state.notifications = notifications
    },

    SET_LOADING(state, loading) {
        state.loading = loading
    },

    SET_ERROR(state, error) {
        state.error = error
    },

    MARK_AS_READ(state, notificationId) {
        const notification = state.notifications.find(n => n.id === notificationId)
        if (notification) {
            notification.read_at = new Date().toISOString()
        }
    },

    MARK_ALL_AS_READ(state) {
        const now = new Date().toISOString()
        state.notifications.forEach(notification => {
            if (!notification.read_at && notification.type !== 'task') {
                notification.read_at = now
            }
        })
    },

    REMOVE_NOTIFICATION(state, notificationId) {
        state.notifications = state.notifications.filter(n => n.id !== notificationId)
    },

    ADD_NOTIFICATION(state, notification) {
        const exists = state.notifications.some(n => n.id === notification.id)
        if (!exists) {
            const newNotification = {
                ...notification,
                read_at: notification.read_at || null
            }
            state.notifications.unshift(newNotification)
        }
    }
}
